import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../../../../store/app";
import axios from "axios";

interface FooterState {
  appLoading: boolean;
  isLoading: boolean;
}

const initialState = {
  appLoading: true,
  isLoading: false,
} as FooterState;

const FooterSlice = createSlice({
  name: "FOOTER",
  initialState,
  reducers: {
    setAppLoading: (state, action: PayloadAction<boolean>) => {
      state.appLoading = action.payload;
    },
    start: (state) => {
      state.isLoading = true;
    },
  },
});

export const { setAppLoading, start } = FooterSlice.actions;

const headers = {
  accept: "application/json",
  fromapp: 4,
  apikey: "GITEX@8RGIP28KTR2023",
};
const APIURL =
  "https://mncrw3ml6jgxc4hzvckhk3imzq0kgllb.lambda-url.us-east-1.on.aws/";
// const LOCALAPIURL = "https://yonkzxu5nm7txaxts3pmcxxeaa0mywid.lambda-url.us-east-1.on.aws/";

export const doNewsletterSubscribe =
  (payload: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await axios.post(APIURL, payload, {
        headers: headers,
      });
      setAppLoading(false);
      return Promise.resolve(response);
    } catch (error: any) {
      const errResponse = error?.response?.data || error;
      return Promise.reject(errResponse);
    }
  };

const FooterSliceReducer = FooterSlice.reducer;
export default FooterSliceReducer;
